import { StyleSheet , Font } from "@react-pdf/renderer";


Font.register({
  family: "IRANSansX-FaNum",
  src: "/fonts/IRANSansX-FaNum.ttf",
});
Font.register({
  family: "IRANSansX-Medium",
  src: "/fonts/IRANSansX-Medium.ttf",
});
Font.register({
  family: "IRANSansX-Bold",
  src: "/fonts/IRANSansX-Bold.ttf",
});

Font.register({
  family: "IRANSansX-Regular",
  fonts: [
    {
      src: "/fonts/IRANSansX-Regular.ttf",
      fontWeight: "normal",
    },
  ],
});
Font.register({
  family: "BYekan",
  fonts: [
    {
      src: "/fonts/BYekan.ttf",
      fontWeight: "Bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 5,
    backgroundColor: "#ffffff",
    direction: "rtl",
    fontSize: 10,
    fontFamily: "IRANSansX-Regular",
  },

  invoice: {
    flexDirection: "column",
  },

  // HEADER
  header: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 5,
    marginBottom: 5,
  },
  titleBox: {
    width: 290,
    backgroundColor: "#832865",
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRightWidth: 0,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
  },
  titleText: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#fff",
    family: "IRANSansX-Medium",
  },
  orderRow: {
    flexDirection: "row-reverse", // ✔ REQUIRED
    alignItems: "center", // ✔ vertical alignment
    gap: 4, // ✔ spacing between texts
    marginVertical: 4,
    justifyContent: " flex-end",
    fontSize: 10,
  },
  orderStrong: {
    fontSize: 10,
    family: "IRANSansX-Medium",
    color: "#832865",
  },
  orderInfo: {
    flex: 1,
    paddingRight: 30,
    gap: 4,
  },
  barcodeBox: {
    width: 70,
    alignItems: "center",
  },
  barcodeImage: {
    width: 70,
    height: 70,
  },

  // INFO SECTION
  infoRow: {
    flexDirection: "row-reverse",
    gap: 20,
    marginBottom: 30,
  },

  infoRow: {
    flexDirection: "row-reverse",
    gap: 20,
  },

  sellerCard: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#dcdcdc",
    padding: 10,
    backgroundColor: "#fff",
    gap: 6,
    borderRightWidth: 0,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
  },

  customerCard: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#dcdcdc",
    padding: 10,
    backgroundColor: "#f7f7f7",
    gap: 6,
    borderLeftWidth: 0,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
  },

  cardTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#832865",
    marginBottom: 1,
    textAlign: "right",
    family: "IRANSansX-Bold",
  },

  cardText: {
    color: "#555",
    lineHeight: 1.1,
    fontSize: 8,
    textAlign: "right",
    family: "IRANSansX-FaNum",
  },

  // PRODUCTS TABLE
  productsBox: {
    marginTop: 10,
    marginBottom: 10,
    borderCollapse: "collapse",
  },

  tableHeaderRow: {
    flexDirection: "row-reverse",
    backgroundColor: "#832865",
    color: "#fff",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },

  th: {
    display: "flex",
    flex: 1,
    padding: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    justifyContent: "center", // ✔ vertical center
    alignItems: "center", // ✔ horizontal center
    marginHorizontal: "auto",
    family: "IRANSansX-Medium",
  },

  tableBodyRow: {
    flexDirection: "row-reverse",
    borderBottomWidth: 1,
    borderBottomColor: "#ececec",
    textAlign: "center",
  },

  td: {
    flexDirection: "row-reverse",
    display: "flex",
    flex: 1,
    fontSize: 9,
    justifyContent: "center", // ✔ vertical center
    alignItems: "center", // ✔ horizontal center
    textAlign: "center",
  },

  tdInner: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },

  tdName: {
    flex: 5,
    textAlign: "right",
    fontSize: 9,
    flexShrink: 0,
  },

  rowNumberCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: "#832865",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    display: "flex",
    marginHorizontal: "auto",
    fontSize: 9,
  },

  productNameMain: {
    family: "BYekan",
    fontSize: 8,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 3,
    paddingTop: 5,
  },

  attributeText: {
    color: "#d40000",
    fontSize: 8,
    marginBottom: 3,
  },

  expireText: {
    color: "#d40000",
    fontSize: 8,
    marginBottom: 3,
  },

  giftText: {
    color: "#d40000",
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 1,
  },

  // FOOTER
  footerRow: {
    flexDirection: "row-reverse",
    gap: 10,
    marginTop: 10,
  },

  summaryBox: {
    width: 270,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 12,
    overflow: "hidden",
  },

  summaryRow: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    fontSize: 10,
  },

  summaryTotal: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: 10,
    backgroundColor: "#832865",
    color: "#fff",
    fontSize: 12,
    fontWeight: "bold",
    alignItems: "center",

  },

  priceRow: {
    flexDirection: "row-reverse",   // ✔ RTL correct order
    alignItems: "center",
    gap: 6,                         // ✔ spacing between تومان and number
  },

  toman: {
    fontSize: 13,
    color: "#fff",
  },
  priceFaNum: {
    fontFamily: "IRANSansX-FaNum",
    fontSize: 14,
    fontWeight: "bold",
    color: "#fff",
  },

  extraBox: {
    flex: 1,
    flexDirection: "column",
    gap: 10,
  },

  extraCard: {
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 12,
    padding: 5,
  },

  extraTitle: {
    marginBottom: 10,
    color: "#832865",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "right",
    fontFamily: "IRANSansX-Medium",
  },

  extraRow: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    paddingVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    borderStyle: "dashed",
    fontSize: 10,
  },
  extraRowTitle: {
    fontSize: 8,
    fontFamily: "IRANSansX-Medium",
  },
  extraRowTitleEnd: {
    fontSize: 10,
    fontFamily: "IRANSansX-Medium",
  },
  extraRowEnd: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    paddingVertical: 4,
    fontSize: 10,
  },

  noteBox: {
    marginTop: 30,
    width: "100%",
    alignItems: "center",        // ✔ center horizontally
    justifyContent: "center",    // ✔ center vertically inside the box
  },

  noteRow: {
    flexDirection: "row-reverse", // ✔ RTL friendly
    alignItems: "center",         // ✔ vertical center
    justifyContent: "center",     // ✔ horizontal center
    gap: 6,                       // ✔ spacing between text & icon
  },

  noteText: {
    fontSize: 10,
    fontFamily: "IRANSansX-Medium",
    color: "#555",
  },

  icon: {
    width: 16,
    height: 16,
  },

  giftIcon: {
    width: 10,
    height: 10,

  },

});
export default styles;